export class HistogrammeStock {
    static jsonMap = {
        numMois: 'numMois',
        quantite: 'quantite'
    };

    numMois: number = undefined;
    quantite: number = undefined;
}
